import { Link } from "react-router-dom";
import { ClipboardCheck, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useDocs } from "@/lib/DocsContext";
import { copyText } from "@/lib/docs";

export const ApprovalBanner = ({ compact = false }) => {
  const { manifest } = useDocs();
  if (!manifest) return null;
  const approved = manifest.status === "approved";

  const copy = async () => {
    await copyText(manifest.approval_template);
    toast.success(approved ? "Evidencija odobrenja je kopirana." : "Tekst odobrenja dokumentacije je kopiran. Prije slanja upišite konačni GitHub commit SHA; G1a traži zasebnu uputu.");
  };

  return (
    <section
      role="status"
      data-testid={approved ? "approval-approved-banner" : "approval-pending-banner"}
      className={`relative overflow-hidden rounded-lg border ${approved ? "border-ok/30 bg-ok/10" : "border-warn/30 bg-warn/10"} ${compact ? "p-4" : "p-5 sm:p-6"}`}
    >
      <span className={`absolute inset-y-0 left-0 w-1 ${approved ? "bg-ok" : "bg-warn"}`} aria-hidden />
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        {approved ? <ClipboardCheck className="h-6 w-6 shrink-0 text-ok" /> : <ShieldAlert className="h-6 w-6 shrink-0 text-warn" />}
        <div className="min-w-0 flex-1">
          <p className={`font-mono text-[10px] font-semibold uppercase tracking-[0.2em] ${approved ? "text-ok" : "text-warn"}`}>
            Status · {manifest.version} · {manifest.date}
          </p>
          <p className={`mt-1 text-foreground ${compact ? "text-sm" : "text-sm sm:text-base"}`} data-testid="approval-banner-text">
            {approved
              ? "G0-R rev. 2 odobren za a9a736e; G1a razvoj sa sintetičkim podacima dopušten zasebno. U-01 ostaje otvoren prije live upisa; G1b nije odobren."
              : "G0-R rev. 2 je pripremljen za pregled. Čeka pisano odobrenje konačnog commita dokumentacije; ni to samo po sebi ne pokreće G1a razvoj."}
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          {approved ? (
            <>
              <Button size="sm" variant="outline" onClick={copy} data-testid="copy-decision-summary-btn">
                <ClipboardCheck /> Kopiraj sažetak odluke
              </Button>
              <Button size="sm" variant="outline" asChild>
                <Link to="/doc/review/G0-R-REV2-APPROVAL.md" data-testid="approval-record-link">Evidencija odluka</Link>
              </Button>
            </>
          ) : (
            <Button size="sm" onClick={copy} data-testid="copy-approval-text-btn" className="bg-warn text-black hover:bg-warn/90">
              <ClipboardCheck /> Kopiraj tekst odobrenja
            </Button>
          )}
          {!compact && (
            <Button size="sm" variant="outline" asChild>
              <Link to="/doc/G0-CORRECTIONS.md" data-testid="banner-open-questions-link">
                Registar korekcija
              </Link>
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};
